import request from "@/request/index";
// export function getList(data){
//     return request({
//         url:'fore/homepage/getLatestNews.do',
//         method:'get',
//         params:data
//     })
// }
//最新资讯查询
export function getListZx(data) {
  return request({
    url: "fore/homepage/getLatestNews.do",
    method: "post",
    data,
  });
}
//协会通知查询
export function getAssociationNotice(data) {
  return request({
    url: "fore/homepage/getNotice.do",
    method: "post",
    data,
  });
}
export function AssociationNotice(data) {
  return request({
    url: "fore/meeting/getAssociationNotice.do",
    method: "post",
    data,
  });
}

export function AssociationNoticeDetail(data) {
  return request({
    url: "fore/meeting/getDetailedInformation.do",
    method: "post",
    data,
  });
}
//行业资讯
export function getIndustry(data) {
  return request({
    url: "fore/news/getLatestInformation.do",
    method: "post",
    data,
  });
}
//行业资讯查单条
export function queryInformation(data) {
  return request({
    url: "fore/news/getNewsById.do",
    method: "post",
    data,
  });
}
//展会信息查询
export function getExibitionList(data) {
  return request({
    url: "fore/homepage/getShowInformation.do",
    method: "post",
    data,
  });
}
//精彩图集
export function getWonderfulAtlas(data) {
  return request({
    url: "fore/homepage/getAtlas.do",
    method: "post",
    data:{ 'parms': JSON.stringify( data)}
  });
}
//推荐企业
export function getRecommended(data) {
  return request({
    url: "fore/homepage/getCustomer.do",
    method: "post",
    data:{ 'parms': JSON.stringify( data)}
  });
}
//外贸预警
export function getWar(data) {
  return request({
    url: "fore/earlywarning/getWarning.do",
    method: "post",
    data,
  });
}
//预警明细
export function getWarDetail(data) {
  return request({
    url: "fore/earlywarning/getWarningById.do",
    method: "post",
    data,
  });
}
//展会信息更多
export function moreInformation(data) {
  return request({
    url: "/fore/news/getMoreShowInfo.do",
    method: "post",
    data,
  });
}
//展会信息明细
export function industryDetail(data) {
  return request({
    url: "/fore/news/getMoreShowById.do",
    method: "post",
    data,
  });
}
//协会活动
export function move(data) {
  return request({
    url: "/fore/news/getActivities.do",
    method: "post",
    data,
  });
}
//协会活动详情
export function moveDetail(data) {
  return request({
    url: "/fore/news/getActivitiesById.do",
    method: "post",
    data,
  });
}
//协会概况
export function general(data) {
  return request({
    url: "/fore/news/getsurver.do",
    method: "post",
    data,
  });
}
//协会章程
export function rules(data) {
  return request({
    url: "/fore/news/getconstitution.do",
    method: "post",
    data,
  });
}
//企业名录
export function getcustomer(data) {
  return request({
    url: "/directories/getcustomer.do",
    method: "post",
    data,
  });
}
//企业名录查看详情
export function getcustomerDetail(data) {
  return request({
    url: "/directories/getcustomerById.do",
    method: "post",
    data,
  });
}
//初始化菜单
export function getDirectory(data){
  return request({
      url:'fore/news/getCustomer.do',
      method:"post",
      data:{ 'parms': JSON.stringify( data)}
  })
}
//在线留言
export function onLine(data){
  return request({
      url:'contactus/onlinemessage/SaveData.do',
      method:"post",
      data:{ 'parms': JSON.stringify( data)}
  })
}
//动态菜单
export function dynamicMenu(data){
  return request({
      url:'fore/homepage/getDynamic.do',
      method:"post",
      data:{ 'parms': JSON.stringify( data)}
  })
}
//行业专栏
export function getSpecial(data){
  return request({
      url:'fore/earlywarning/getSpecial.do',
      method:"post",
      data:{ 'parms': JSON.stringify( data)}
  })
}
//行业专栏
export function querySpecial(data){
  return request({
      url:'fore/earlywarning/getSpecialById.do',
      method:"post",
      data:{ 'parms': JSON.stringify( data)}
  })
}
//联系信息
export function getContactus(data){
  return request({
      url:'contactus/contactus/getContactus.do',
      method:"post",
      data:{ 'parms': JSON.stringify( data)}
  })
}
//申请入会
export function apply(data){
  return request({
      url:'membership/SaveData.do',
      method:"post",
      data:{ 'parms': JSON.stringify( data)}
  })
}
//协会会刊
export function getProceedings(data){
  return request({
      url:'/fore/news/getproceedings.do',
      method:"post",
      data:{ 'parms': JSON.stringify( data)}
  })
}
//图片上传
export function up(data){
  return request({
      url:'webupload',
      method:"post",
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      data
  })
}
//前端菜单模块图片
export function getMenuImg(data){
  return request({
      url:'fore/earlywarning/getMenuImgs.do',
      method:"post",
      data:{ 'parms': JSON.stringify( data)}
  })
}
//获取电话号码

export function getPhone(data){
  return request({
      url:'fore/homepage/getPhone.do',
      method:"post",
      data:{ 'parms': JSON.stringify( data)}
  })
}